export function cx(...classNames: (string | undefined | false | null | "")[]): string {
    let res, i;
    for (res = "", i = 0; i < classNames.length; i++) {
        if (!classNames[i]) continue;

        const separator: string = res.length > 0 ? " " : ""; // avoid inserting extra space on first class
        res = `${res}${separator}${classNames[i]}`;
    }
    return res;
}
